(() => {
  const root = document.querySelector('[data-sa-pdp-content]');
  if (!root) return;

  const links = [...root.querySelectorAll('.sa-pdp-nav a[href^="#"]')];
  const sections = links
    .map((link) => document.querySelector(link.getAttribute('href')))
    .filter(Boolean);

  const setActive = (id) => {
    links.forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
    });
  };

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      setActive(target.id);
      target.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'start',
      });

      if (window.history.replaceState) {
        window.history.replaceState(null, '', `#${target.id}`);
      }
    });
  });

  if ('IntersectionObserver' in window && sections.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: '-25% 0px -60% 0px', threshold: [0, 0.1, 0.4] }
    );
    sections.forEach((section) => observer.observe(section));
  }

  root.querySelectorAll('.sa-pdp-faq details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      root.querySelectorAll('.sa-pdp-faq details[open]').forEach((other) => {
        if (other !== details) other.open = false;
      });
    });
  });

  customElements.whenDefined('product-recommendations').then(() => {
    root.querySelectorAll('product-recommendations.sa-pdp-recommendations').forEach((recommendations) => {
      if (recommendations.textContent.trim() || recommendations.dataset.saLoadRequested === 'true') return;

      recommendations.dataset.saLoadRequested = 'true';
      recommendations.observer?.unobserve(recommendations);
      recommendations.loadRecommendations?.(recommendations.dataset.productId);
    });
  });
})();
